export default __webpack_public_path__ + "static/avatar-special-engin-0-detail-47083f7c022d8533a339ccaba8914928.png";